export default __webpack_public_path__ + "static/pcc-logo-a0cd8550333da497d0033d8a28af9e1f.svg";